import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { seasonalPeriodPageConfig } from "./seasonalPeriodPageConfig";

export const seasonalPeriodRecordDefinition: RecordDefinition = {
  path: "/seasonal-period",
  entityName: "dwseasonalperiod",
  listRoute: "/seasonal-periods",
  backTitle: "Back to seasonal periods",
  allowedRoles: administratorRoles,
  config: seasonalPeriodPageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Seasonal Period",
    newRecordTitle: "New Seasonal Period",
  },
};
